<template>
    <div id="pricing" v-if="stripePrices" class="pricing mb-sm-0 mb-5" :class="{'not-authenticated': !userId}">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <div class="pricing__wrapper">  
                        <div class="pricing__plan-cards">
                            <PlanCard
                                v-for="(card, index) in usePricingData"
                                :key="`${card.title}-${index}`"
                                :plan-data="card"
                                :price-data="priceData"
                                @handleCardAction="planCardActionsHandler"
                            >
                                <template #plan-card-badge>
                                    <PlanBadge type="bestDeal" v-if="index === 1 && bestDeal && priceData && bestDeal.priceId === priceData.priceId" align="left"/> 
                                    <PlanBadge type="currentPlan" v-if="currentPlanIndex === index" :index="currentPlanIndex"/>
                                </template>
                                <template #plan-card-body>
                                    <div v-if="index === 0" class="pricing__basic-plan pricing__plan">
                                        <p class="pricing__plan__title">
                                            <span>$</span>0
                                        </p>
                                    </div>
                                    <div v-if="index === 1" class="pricing__premium-plan pricing__plan">
                                        <p class="pricing__plan__title">
                                            <span>$</span>{{priceData && priceData.price}}
                                        </p>
                                        <div class="pricing__premium-plan__switcher">
                                            <button 
                                                v-for="(item) in stripePrices" 
                                                :key="item.price"
                                                class="pricing__premium-plan__switcher-item"
                                                :class="{'pricing__premium-plan__switcher-item__active': priceData && priceData.priceId === item.priceId}"
                                                @click="setPrice(item)"
                                            >
                                                {{item.days}} Days
                                            </button>
                                        </div>
                                    </div>
                                    <div v-if="index === 2" class="pricing__vip-plan pricing__plan">
                                        <p class="pricing__plan__title">
                                            <span>Custom</span>
                                        </p>
                                        <span class="description">
                                            Individual Contract
                                        </span>
                                    </div>
                                </template>
                            </PlanCard>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Benefits/>
        <Community 
            :external="true"
            externalTitle="What are creators saying?"
            iconPrev="landing-arrow-prev"
            iconNext="landing-arrow-prev"
            :pagination="pagination"
        />                        
        <div class="pricing__faq-wrapper">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-lg-8 col-md-12">
                        <div class="pricing__faq-wrapper__title">
                            FAQ
                        </div>
                        <Faq/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Trial from './Trial'
import Service from './Service'
import Benefits from './Benefits'
import Community from '../../views/LandingPage/Community'
import Faq from './Faq'
import Footer from '../../views/LandingPage/Footer'
import {ref, computed, onMounted, watch} from '@vue/composition-api'
import {useStore, useUserId} from '../../core/hooks'
import PlanCard from './PlanCard'
import {usePricingData} from './usePricingPlanData'
import PlanBadge from './PlanBadge'

export default {
    name: 'Pricing',
    components: {
        Trial,
        Service,
        Benefits,
        Community,
        Footer,
        PlanCard,
        Faq,
        PlanBadge
    },
    setup: function(props, context) {
        let icon = ref()
        let text = ref()

        const {store, state} = useStore()
        const {userId} = useUserId()
        const hasTrialAlert = computed(() => store.getters.hasTrial && !store.getters.membershipStatus)
        const stripePrices = computed(() => state.value.stripePrices)
        const membershipStatus = computed(() => store.getters.membershipStatus)
        const publishedCampaignIds = computed(() => state.value.publishedCampaignIds)
        const inPremium = computed(() => store.getters.inPremium)
        const priceData = ref(null)

        const currentPlanIndex = ref(-1)

        const bestDeal = ref(null)
        
        onMounted(() => {
            window.scrollTo({ top: 0})

            if(state.value.user) {
                currentPlanIndex.value = inPremium.value ? 1 : 0
            }

            if(!publishedCampaignIds.value.length) {
                return priceData.value = stripePrices.value[0]
            }

            if(inPremium.value){
                return priceData.value = stripePrices.value.find(item => item.days === Number(state.value.user.premiumPlan.days))
            }

            const userCampaigns = publishedCampaignIds.value.sort((a,b)=> b.created_at.seconds - a.created_at.seconds)
            const newestCampaignsDaystogo = userCampaigns[0].daystogo

            switch(true){
                case newestCampaignsDaystogo < 20:
                    priceData.value = stripePrices.value[0];
                    break
                case newestCampaignsDaystogo < 35:
                    priceData.value = stripePrices.value[1];
                    break
                default: 
                    priceData.value = stripePrices.value[2];
                    break
            }

            bestDeal.value = {...priceData.value}

        })
        const pagination = {
            el: '.swiper-pagination',
            type: 'bullets',
            clickable: true
        }
        const setPrice = (selectedOption) => {
            priceData.value = selectedOption 
        }
        const calendly = () => {
            // context.root.$sendMixpanelEvent('Calendly Modal Opened', {
            //     'Opened From': 'Landing Phone Icon'
            // })
            // context.root.$ga.event('Calendly', 'Modal Opened', 'OpenedFrom', 'Landing Phone Icon')
            Calendly.initPopupWidget({
                url: 'https://calendly.com/teamcrossprom/crossprom-for-your-kickstarter-campaign'
            })
        }
        
        const planCardActionsHandler = (val) => {
            if(val === 'VIP') {
                calendly()
            }
            if(val === 'Basic Plan') {
                if(userId) {
                    return
                }
                store.commit('TOGGLE_MODAL', ['sign-up', true])
            }
        }
        return {
            hasTrialAlert,
            userId,
            usePricingData,
            stripePrices,
            membershipStatus,
            priceData,
            pagination,
            setPrice,
            planCardActionsHandler,
            inPremium,
            bestDeal,
            currentPlanIndex
        }
    }
}
</script>

<style lang="scss" scoped>
$plan_title_color: #333333;
$plan_fontsize: 40px;
$plan_lineheight: 48px;
$font_bold: 'Eina Bold';
$font_semibold: 'Eina SemiBold';
.pricing {
    padding-top: 32px;
    &.not-authenticated {
        padding-top: 100px;
    }
    &__community {
        background: #F8F8FF;
    }
    &__plan-cards {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        @media (max-width: 992px) {
            grid-template-columns: repeat(1, 1fr);
        }
        
        .plan-card {
            &:nth-child(2) {
               box-shadow: 8px 0px 24px rgba(8, 35, 48, 0.04), -8px 0px 24px rgba(8, 35, 48, 0.04);
               z-index: 1;
            }
            &:first-child {
                border-radius: 12px 0 0 12px;
            }
            &:last-child {
                border-radius: 0 12px 12px 0;
            }
        }
    }
    &__wrapper {
        min-height: calc(100vh - 100px);
        @media (max-width: 992px) {
            min-height: auto;
        }
    }
    &__faq-wrapper {
        background: #ffffff;
        padding: 100px 0;
        min-height: calc(100vh - 120px);
        &__title {
            font-size: 32px;
            line-height: 40px;
            color: #333333;
            font-family: $font_bold;
            margin-bottom: 48px;
            text-align: center;
        }
    }
    &__plan__title {
        font-size: $plan_fontsize;
        line-height: $plan_lineheight;
        color: $plan_title_color;
        margin-bottom: 0;
        font-family: $font_bold;
        text-align: center;
        display: flex;

        span {
            font-family: $font_bold;
            font-size: 24px;
            line-height: 32px;

        }     
    }
    &__plan {
        display: flex;
        flex-direction: column;
        align-items: center;
    }
    &__premium-plan {
        margin-top: 16px;
        &__switcher {
            padding: 4px;
            background: #F4F7FA;
            border-radius: 8px;
            max-width: 222px;
            width: 100%;
            display: flex;
            justify-content: space-between;
            margin-top: 8px;
        }
        &__switcher-item {
            padding: 4px 12px;
            border-radius: 8px;
            color: $plan_title_color;
            font-size: 11px;
            line-height: 16px;
            font-family: $font_semibold;
            &__active {
                background: #727CF5;
                color: #ffffff;
            }
        }
    }
    &__vip-plan {
        .description {
            font-size: 14px;
            line-height: 20px;
            color: #718096;
        }
    }
}
div#pricing {
    background: #F4F7FA;
    div[data-name="title"] {
        justify-content: center;
        margin-top: 25px;
        margin-bottom: -20px;
        p {
            font-weight: 600;
            font-size: 32px;
            line-height: 19px;
            color:#858585;
            letter-spacing: 0.12em;
            margin: 0;
        }
    }
    div[data-name="section-header"] {
        p {
            text-align: center;
            color: #333333;
            font-size: 26px;
            line-height: 39px;
            font-weight: bold;
            margin-top: 70px;
            margin-bottom: 0;
            font-family: $font_bold;

            @media screen and (min-height: 900px) {
                margin-top: 30px;
                margin-bottom: 1rem;
                font-size: 32px;
            }

            &.hasTrialAlert {
                margin-top: 55px;
            }
            span {
                color: #727CF5;
            }
        }
    }
    div[data-name="section-body"] {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 0;
        transform: scale(0.8);
        margin-top: -20px;

        @media screen and (min-height: 850px) {
            transform: scale(1);
            margin-top: 50px;
        }
    }


    &.not-authenticated {
        div[data-name="section-body"] { 
            transform: scale(0.9);
            margin-top: 20px;

            @media screen and (min-height: 850px) {
                transform: scale(1);
                margin-top: 50px;
            }
        }

        div[data-name="section-header"] { 
            margin-top: 100px;
            @media screen and (min-height: 900px) {
                margin-top: 70px;
            }
        }
    }
}
@media (max-width: 576px) {
div#pricing {
    div[data-name="section-header"] {
        p {
            font-size: 23px;
        }
    }    
}

}

</style>